import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {CommissionStatusType} from "../../types/commission-status.type";
import {CommonsAlertsService} from "../../../commons/services/commons-alerts.service";
import {SortType} from "../../../commons/types/sort.type";
import {CommissionDeltaType} from "../../types/commission-delta.type";
import {ServiceStatus} from "../../../deliveries/constants/service-status.type";

export class CommissionsTableCtrl implements IController {
  ids: string[];
  consolidatedId: string;
  accountId: string;
  accountIds: string[];
  agentId: string;
  agentIds: string[];
  shipperAccountIds: string[];
  from: string;
  to: string;
  query: any;
  statuses: CommissionStatusType[];
  sortName: string;
  sortType: SortType;
  isConsolidated: boolean;
  commissionDelta: CommissionDeltaType;
  serviceStatuses: ServiceStatus[];
  canDelete: boolean;
  selectedIds: string;
  excludeMode: boolean;
  canMultiSelect: boolean;
  onSelect: Function;
  onSortChange: Function;
  onMarkAsPaid: Function;
  onPay: Function;
  onEditPrice: Function;
  onConsolidate: Function;
  onDelete: Function;
  onRemoveConsolidate: Function;
  onReject: Function;
  onRestore: Function;
  onSelectRow: Function;

  public commissionsRef: any;
  public loadLimit = 20;
  public infiniteScroll: any;
  public isScrollable: any;
  public selectedKeys: any;
  public asceDescIconsMap: any;
  public commissionDeltaType: typeof CommissionDeltaType = CommissionDeltaType;


  constructor(private $infiniteScroll, private $commission, private moment, private $log, private commonsAlertsService: CommonsAlertsService, private commonsConstants) {
    this.asceDescIconsMap = this.commonsConstants.sortIconsMap;
  }

  $onInit() {
    this.commissionsRef = this.$commission();
    this.commissionsRef.$query(this._getQuery());
    this.infiniteScroll = this.$infiniteScroll(this.commissionsRef, this.loadLimit);
    this.selectedKeys = {};
  };

  $onChanges(changes) {
    if (changes.selectedIds && !changes.selectedIds.isFirstChange()) {
      this.selectedKeys = {};
      _.forEach(this.selectedIds, (id) => {
        this.selectedKeys[id] = true;
      })
    }

    //   canMultiSelect: '<',
    //   accountIds: '<?',
    //   excludeMode: '<',
    //   selectedIds: '<?',

    if (
      (changes.ids && !changes.ids.isFirstChange()) ||
      (changes.consolidatedId && !changes.consolidatedId.isFirstChange()) ||
      (changes.accountId && !changes.accountId.isFirstChange()) ||
      (changes.shipperAccountIds && !changes.shipperAccountIds.isFirstChange()) ||
      (changes.agentId && !changes.agentId.isFirstChange()) ||
      (changes.agentIds && !changes.agentIds.isFirstChange()) ||
      (changes.accountIds && !changes.accountIds.isFirstChange()) ||
      (changes.from && !changes.from.isFirstChange()) ||
      (changes.to && !changes.to.isFirstChange()) ||
      (changes.statuses && !changes.statuses.isFirstChange()) ||
      (changes.sortName && !changes.sortName.isFirstChange()) ||
      (changes.sortType && !changes.sortType.isFirstChange()) ||
      (changes.isConsolidated && !changes.isConsolidated.isFirstChange()) ||
      (changes.commissionDelta && !changes.commissionDelta.isFirstChange()) ||
      (changes.serviceStatuses && !changes.serviceStatuses.isFirstChange()) ||
      (changes.query && !changes.query.isFirstChange())
    ) {
      this._loadCommissions();
    }
  };

  _loadCommissions() {
    this.commissionsRef.$query(this._getQuery())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.commonsAlertsService.somethingWentWrongError();
        this.$log.error('Failed to load billing accounts ', error);
      })
  }

  $doCheck() {
    this.isScrollable = true;
  };


  onToggleSelectAll() {
    this.onSelect({selectedIds: [], excludeMode: !this.excludeMode});
  }

  onToggleSelected(commission) {
    this.selectedKeys[commission.id] = !this.selectedKeys[commission.id];
    const selectedIds = _.includes(this.selectedIds, commission.id) ?
      _.filter(this.selectedIds, (id) => {
        return id !== commission.id;
      }) :
      _.concat(this.selectedIds, [commission.id]);

    this.onSelect({selectedIds: selectedIds, excludeMode: this.excludeMode});
  }

  setEvents() {
    const div1 = document.getElementById('header');
    const div2 = document.querySelectorAll('.md-virtual-repeat-scroller')[0];

    div2.addEventListener('scroll', e => {
      div1.scrollTop = div2.scrollTop;
      div1.scrollLeft = div2.scrollLeft;
    }, {passive: true})
  }

  _getQuery() {
    return {
      limit: this.loadLimit,
      // ids: this.ids,
      consolidatedId: this.consolidatedId,
      accountIds: this.accountIds ? this.accountIds : (this.accountId ? [this.accountId] : undefined),
      agentIds: this.agentIds ? this.agentIds : (this.agentId ? [this.agentId] : undefined),
      shipperAccountIds: this.shipperAccountIds,
      from: this.from,
      to: this.to,
      searchTerm: this.query,
      status: this.statuses,
      ignoreConsolidated: !_.isUndefined(this.isConsolidated) ? !this.isConsolidated : undefined,
      overcharge: this.commissionDelta === this.commissionDeltaType.overcharge ? true : null,
      undercharge: this.commissionDelta === this.commissionDeltaType.undercharge ? true : null,
      noGap: this.commissionDelta === this.commissionDeltaType.noGap ? true : null,
      serviceStatus: this.serviceStatuses,
      sort: (!!this.sortName && !!this.sortType) ? `${this.sortName},${this.sortType}` : undefined
    }
  }

}

angular
  .module('bringoz.admin.commissions')
  .component('commissionsTable', {
    bindings: {
      ids: '<?',
      canMultiSelect: '<',
      consolidatedId: '<?',
      accountIds: '<?',
      accountId: '<?',
      shipperAccountIds: '<?',
      agentId: '<?',
      agentIds: '<?',
      from: '<',
      to: '<',
      excludeMode: '<',
      query: '<?',
      statuses: '<?',
      sortName: '<?',
      sortType: '<?',
      isConsolidated: '<?',
      commissionDelta: '<?',
      serviceStatuses: '<?',
      canDelete: '<?',
      selectedIds: '<?',
      onSelect: '&',
      onSortChange: '&',
      onMarkAsPaid: '&',
      onPay: '&',
      onEditPrice: '&',
      onConsolidate: '&',
      onDelete: '&',
      onRemoveConsolidate: '&',
      onReject: '&',
      onRestore: '&',
      onSelectRow: '&'
    },
    template: require('./commissions-table.html').default,
    controller: CommissionsTableCtrl
  });
